/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RecordingBitratePreset {
}

export enum RecordingBitratePreset_Enum {
  OPTIMIZE_FOR_QUALITY = 0,
  OPTIMIZE_FOR_SIZE = 1,
  UNRECOGNIZED = -1,
}

export function recordingBitratePreset_EnumFromJSON(object: any): RecordingBitratePreset_Enum {
  switch (object) {
    case 0:
    case "OPTIMIZE_FOR_QUALITY":
      return RecordingBitratePreset_Enum.OPTIMIZE_FOR_QUALITY;
    case 1:
    case "OPTIMIZE_FOR_SIZE":
      return RecordingBitratePreset_Enum.OPTIMIZE_FOR_SIZE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingBitratePreset_Enum.UNRECOGNIZED;
  }
}

export function recordingBitratePreset_EnumToJSON(object: RecordingBitratePreset_Enum): string {
  switch (object) {
    case RecordingBitratePreset_Enum.OPTIMIZE_FOR_QUALITY:
      return "OPTIMIZE_FOR_QUALITY";
    case RecordingBitratePreset_Enum.OPTIMIZE_FOR_SIZE:
      return "OPTIMIZE_FOR_SIZE";
    case RecordingBitratePreset_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRecordingBitratePreset(): RecordingBitratePreset {
  return {};
}

export const RecordingBitratePreset = {
  encode(_: RecordingBitratePreset, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RecordingBitratePreset {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecordingBitratePreset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RecordingBitratePreset {
    return {};
  },

  toJSON(_: RecordingBitratePreset): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RecordingBitratePreset>, I>>(base?: I): RecordingBitratePreset {
    return RecordingBitratePreset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecordingBitratePreset>, I>>(_: I): RecordingBitratePreset {
    const message = createBaseRecordingBitratePreset();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
